module.exports = __webpack_public_path__ + "img/motie.3059ba40.svg";